import type { SerializedUploadNode } from '@payloadcms/richtext-lexical';
import type { JSXConverters } from '@payloadcms/richtext-lexical/react';
import type { AspectRatio, Media } from '@/payload-types';

import { MediaDisplay } from '@/components/media-display';

export const UploadJSXConverter: JSXConverters<SerializedUploadNode> = {
  upload: ({ node }: { node: SerializedUploadNode }) => {
    const value = node.value as Media & { ratio: AspectRatio };

    if (!value) return null;

    return <MediaDisplay media={value as Media} ratio={value.ratio as AspectRatio} />;
  },
};
